import { Box, BoxProps } from '@material-ui/core';

import { InfoTooltip } from '@/components/modules/Application/components/_shared/components/InfoTooltip';

interface InfoTooltipWrapperProps extends BoxProps {
  textId: string;
  iconStyle?: React.CSSProperties;
}

export const InfoTooltipWrapper = ({
  textId,
  iconStyle = {
    marginLeft: 2,
    fontSize: 14,
  },
  children,
  ...boxProps
}: InfoTooltipWrapperProps) => {
  return (
    <Box display={'flex'} alignItems={'center'} {...boxProps}>
      {children}
      <InfoTooltip textId={textId} iconStyle={iconStyle} />
    </Box>
  );
};
